export class TextConstants
{
  public static readonly MIN_FONT_SIZE: number = 10;
  public static readonly MAX_FONT_SIZE: number = 300;
  // Nur die folgenden Elemente dürfen im Textfeld der Wooooooosh-Komponente
  // verwendet werden. Bei anderen Elementen wird nur der Inhalt (.textContent)
  // übernommen.
  public static readonly TOKENIZE_NODE_WHITELIST: Array<String> =
      ['DIV', 'P', 'BR'];
  // Von folgenden Elementen wird gar nichts übernommen. Diese dürfen nicht in
  // die Wooooooosh-Komponente engefügt werden.
  public static readonly TOKENIZE_TEXT_BLACKLIST: Array<String> =
      ['STYLE', 'TABLE', 'UL', '#comment'];
}
